import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';
import { API_BASE_URL } from '../config';

const VerHonorariosPendientes = ({ id_company, token }) => {
    const [HonorariosPendientes, setHonorariosPendientes] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fetchHonorariosPendientes = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/honorarios-pendientes/${id_company}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setHonorariosPendientes(response.data);
            } catch (error) {
                console.error('Error al obtener los honorarios pendientes:', error);
            }
        };
        fetchHonorariosPendientes();
    }, [id_company, token]);
    const handleRegistrarHonorarios = async () => {
        setLoading(true);
        try {
            await axios.post(
                `${API_BASE_URL}/api/registrar-honorarios`,
                { id_company },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            showSuccess('Honorarios registrados correctamente en asientos contables');
            // Actualizar la lista de gastos pendientes después de registrar
            setHonorariosPendientes(HonorariosPendientes.filter(honorario => honorario.registrado === false));
        } catch (error) {
            console.error('Error al registrar los honorarios:', error);
            showError('Error al registrar los honorarios en asientos contables');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <h1>Honorarios Pendientes mi Wachin</h1>
            <table>
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Monto Bruto</th>
                        <th>Retención</th>
                        <th>Monto Liquido</th>
                        <th>Razon Social</th>
                        <th>RUT</th>
                        <th>N° Boleta</th>
                    </tr>
                </thead>
                <tbody>
                    {HonorariosPendientes.map((honorario) => (
                        <tr key={honorario.id}>
                            <td>{new Date(honorario.fecha).toISOString().slice(0, 10)}</td> 
                            <td>{honorario.bruto}</td>
                            <td>{honorario.retenido}</td>
                            <td>{honorario.pagado}</td>
                            <td>{honorario.nombre_razon_social}</td>
                            <td>{honorario.rut}</td>
                            <td>{honorario.numero_boleta}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button onClick={handleRegistrarHonorarios} disabled={loading}>
                {loading ? 'Registrando...' : 'Registrar Boletas de Honorarios en Asientos Contables'}
            </button>
        </div>
    );
};

export default VerHonorariosPendientes;
